import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import MyContext from "../context/MyContext";
import { Button, Badge } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import { Link, NavLink, useHistory } from "react-router-dom";
import { logOutUser } from "../helpers/apiCalls";
import logo from "./icon/shopwell.png";
import { MdReorder } from "react-icons/md";
import MobileMenu from "./MobileMenu.jsx";
import { GrClose } from "react-icons/gr";

const Header = () => {
  const history = useHistory();
  const context = useContext(MyContext);
  const {
    user,
    cart,
    setUser,
    isAdmin,
    setIsAdmin,
    isLogged,
    setIsLogged,
    categories,
    category,
    setCategory,
    sort,
    setSort,
    search,
    setSearch,
    setAuthIsDone,
    callback,
    setCallback,
    openState,
    setOpenState,
    positionRight,
    setPositionRight,
  } = context;

  const handleLogout = () => {
    setIsLogged(false);
    setIsAdmin(false);
    setUser();
    setAuthIsDone(false);
    logOutUser();
    history.push("/");
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    setSearch("");
  };

  const handleToggleMenu = (positionRight) => {
    setOpenState(!openState);
    setPositionRight(positionRight);
  };

  const goTo = () => {
    setCallback(!callback);
    history.push("/dashboard");
  };

  return (
    <header>
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="AFMT E-Shop" />
        </Link>
      </div>

      <div className="filter_menu">
        <select name="category" value={category} onChange={handleCategory}>
          <option value="">All Products</option>
          {categories.map((category) => (
            <option value={"category=" + category._id} key={category._id}>
              {category.name}
            </option>
          ))}
        </select>
        <input
          type="text"
          value={search}
          placeholder="Enter your search!"
          onChange={(e) => setSearch(e.target.value.toLowerCase())}
        />
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="">Newest</option>
          <option value="sort=oldest">Oldest</option>
          <option value="sort=-sold">Best sales</option>
          <option value="sort=-price">Price: Hight-Low</option>
          <option value="sort=price">Price: Low-Hight</option>
        </select>
      </div>

      <div className="filter_menu_2">
        <ul className="filter_menu_3">
          <li>
            <Link to="/">{isAdmin ? "Products" : "Shop"}</Link>
          </li>
          {isAdmin && (
            <>
              <li>
                <Link to="/create_product">Create Product</Link>
              </li>
              <li>
                <Link to="/category">Categories</Link>
              </li>
              <li>
                <Link to="/allorders">All Orders</Link>
              </li>
            </>
          )}
          {isLogged && !isAdmin && (
            <>
              <li>
                <Link to="/orderhistory">Order History</Link>
              </li>
            </>
          )}

          {user ? (
            <>
              {isAdmin ? (
                <li>{user.fullName}</li>
              ) : (
                <>
                  {user.billAddress ? (
                    <button type="submit" onClick={goTo}>
                      {user.fullName}
                    </button>
                  ) : (
                    <li>
                      <Link to="/add-bill-address">{user.fullName}</Link>
                    </li>
                  )}
                </>
              )}
              <li className="signOut">
                <FontAwesomeIcon
                  title="Logout"
                  onClick={handleLogout}
                  icon={faSignOutAlt}
                />
              </li>
            </>
          ) : (
            <li>
              <Link to="/login">
                <Avatar />
              </Link>
            </li>
          )}
        </ul>
        {!user || isAdmin || (
          <Button component={NavLink} to="/cart" aria-label="Show Cart Item">
            <Badge badgeContent={cart.length} color="secondary">
              <LocalMallIcon />
            </Badge>
          </Button>
        )}
      </div>
      <div className="navbar-details">
        {openState === true ? (
          <GrClose
            style={{ cursor: "pointer" }}
            onClick={() => handleToggleMenu(0)}
          />
        ) : (
          <MdReorder
            style={{ cursor: "pointer" }}
            onClick={() => handleToggleMenu(413)}
          />
        )}
      </div>
      <MobileMenu positionRight={positionRight} />
    </header>
  );
};

export default Header;
